// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__\\+FzYV > button {
  width: 100%;
  margin-top: 1rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/timetracker/submodules/trackedTime/components/TrackedTimeFeed/styles.module.scss"],"names":[],"mappings":"AAAA;EAEQ,WAAW;EACX,gBAAgB,EAAA","sourcesContent":[".container {\n    & > button {\n        width: 100%;\n        margin-top: 1rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__+FzYV`
};
export default ___CSS_LOADER_EXPORT___;
